/**
 * ListColumnVisibilityDropdown - Column toggles for the list table view
 */
import type { ReactElement } from 'react';

import { useAtom } from 'jotai';

import ColumnVisibilityDropdown, { type ColumnGroup } from '@/components/ColumnVisibilityDropdown/ColumnVisibilityDropdown';

import {
  DEFAULT_LIST_COLUMN_VISIBILITY,
  LIST_COLUMN_LABELS,
  LIST_COLUMN_ORDER,
  type ListColumnKey,
  listColumnVisibilityAtom,
} from '../state/listViewSettings';

const COLUMN_GROUPS: ColumnGroup<ListColumnKey>[] = [
  { label: 'Card', columns: ['set', 'type'] },
  { label: 'List entry', columns: ['priority', 'notes'] },
  { label: 'Inventory', columns: ['ownership', 'price'] },
];

export default function ListColumnVisibilityDropdown(): ReactElement {
  const [visibility, setVisibility] = useAtom(listColumnVisibilityAtom);

  const activeCount = LIST_COLUMN_ORDER.filter((column) => visibility[column]).length;

  return (
    <ColumnVisibilityDropdown
      visibility={visibility}
      onToggle={(column) => setVisibility((prev) => ({ ...prev, [column]: !prev[column] }))}
      onReset={() => setVisibility(DEFAULT_LIST_COLUMN_VISIBILITY)}
      groups={COLUMN_GROUPS}
      labels={LIST_COLUMN_LABELS}
      activeCount={activeCount}
    />
  );
}
